import React from "react";

const GoogleTranslate = () => {
  return <div id="google_translate_element"></div>;
};

export default GoogleTranslate;
